import 'owl.carousel'

export default {
  init() {

    $(document).ready(function(){
      $('.owl-carousel').owlCarousel({
        center: true,
        items:1,
        loop:true,
        margin:10,
        nav:true,
        responsiveClass:true,
        responsive:{
          0:{
            items:1,
            nav:true,
          },
          600:{
            items:1,
            nav:true,
          },
          768:{
            items:1,
            nav:true,
          },
          991:{
            items:1,
            nav:true,
          },
          1200:{
            items:3,
            nav:true,
          }
        }

      });
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
